<template>
  <HeadingLv1 text="スペシャルコンテンツ" />

  <LocalNav :list="localNav" class="localNav" :offset="30" />

  <div class="u-containar">
    <p class="">
      国試対策や研修先選びのコツ、医学生団体の紹介など、医学生・研修医に役立つ情報を配信！
    </p>
    <div class="cards">
      <MagazineCard
        v-for="content in outlines"
        :key="content.id"
        :title="content.title"
        :description="content.description"
        :image="content.image"
        :imageAlt="content.imageAlt"
        :path="`/magazines/special/detail/${content.id}`"
        :url="content.url"
        :membershipOnly="content.membershipOnly"
        :date="content.date"
        :category="content.category"
        :showPr="content.isPr"
      />
    </div>
    <Pagination class="pagination" :totalPages="totalPages" />
  </div>

  <section id="test" class="section">
    <h2 class="section_heading u-containar-pc">試験対策</h2>
    <div class="cards u-containar">
      <MagazineCard
        heading="１日１問！国試マスター"
        description="避けては通れない医師国家試験。毎日コツコツ勉強して、苦手分野を克服しよう！"
        :image="require('@/assets/images/magazines/master.png')"
        imageAlt="平日毎日更新１日１問！国試マスター"
        path="/magazines/exam/master"
        membershipOnly
      />

      <MagazineCard
        heading="全国一斉CBT模擬試験"
        description="自分の都合に合わせていつでもオンラインCBT模擬試験を「無料」で受験できます。"
        :image="require('@/assets/images/magazines/cbt_2025_specialthumb.png')"
        imageAlt="全国一斉CBT模擬試験"
        path="/magazines/exam/cbt"
        membershipOnly
      />
    </div>
  </section>

  <section id="matching" class="section">
    <h2 class="section_heading u-containar-pc">マッチング基礎知識</h2>
    <div class="cards u-containar">
      <MagazineCard
        heading="マンガでわかる！研修病院選びの基礎知識"
        description="研修プログラムやマッチングの仕組みなど、初期研修先選びのコツを分かりやすくマンガで解説！"
        :image="require('@/assets/images/magazines/manga.jpg')"
        imageAlt="初期研修は大切な2年間よ！"
        path="/magazines/matching/detail/matching"
      />
    </div>
  </section>

  <MagazineEventArchive />
</template>

<script lang="ts">
import { computed, defineComponent, watch } from 'vue'
import { useRoute } from 'vue-router'
import LocalNav from '@/components/block/LocalNav.vue'
import MagazineCard from '@/components/block/MagazineCard.vue'
import MagazineEventArchive from '@/components/block/MagazineEventArchive.vue'
import Pagination from '@/components/block/Pagination.vue'
import HeadingLv1 from '@/components/elements/HeadingLv1.vue'
import { useSpecial } from '@/provider/special'
import { MagazineSpecialOutline } from '@/types/MagazineSpecial'

export default defineComponent({
  name: 'MagazinesSpecial',

  components: {
    LocalNav,
    MagazineCard,
    HeadingLv1,
    MagazineEventArchive,
    Pagination
  },

  setup() {
    const localNav = [
      {
        id: 'test',
        label: '試験対策'
      },
      {
        id: 'matching',
        label: 'マッチング基礎知識'
      }
    ]

    const route = useRoute()
    const { state, loadContents } = useSpecial()
    const loadSpecialContents = () => {
      loadContents({
        perPage: 6,
        page: route.query.page ? Number(route.query.page) : undefined,
        parentCategory: 'special'
      })
    }
    watch(
      () => [route.params.id, route.query.page],
      (next, prev) => {
        if (JSON.stringify(next) === JSON.stringify(prev)) return
        loadSpecialContents()
      },
      { immediate: true }
    )

    const totalPages = computed(() => state.totalPages)

    const outlines = computed((): MagazineSpecialOutline[] =>
      state.contents.map((content) => ({
        ...content,
        category: content.childCategories[0]?.name ?? ''
      }))
    )

    return {
      localNav,
      totalPages,
      outlines
    }
  }
})
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables'as var;

.u-containar {
  margin-top: 15px;

  > p:first-child {
    margin-top: 29px;
    margin-bottom: 40px;
    font-size: 1.6rem;
    line-height: 1.875;
  }
}

.section {
  margin-top: 50px;
}

.section_heading {
  display: flex;
  align-items: center;
  min-height: 50px;
  padding-left: 16px;
  padding-right: 16px;
  background-color: #e7f8f6;
  font-weight: 500;
  font-size: 2rem;
  letter-spacing: 0.03em;
  line-height: 1.6;

  & + * {
    margin-top: 24px;
  }
}

.magazineCard + .button {
  margin-top: 23px;
}

::v-deep(.recommend_list .magazineCard_heading) {
  font-size: 1.4rem;
  line-height: 1.5;
}

.cards {
  display: grid;
  grid-template-columns: 1fr;
  gap: 30px;
  margin-bottom: 30px;
  @include mixins.media() {
    grid-template-columns: repeat(3, 1fr);
  }
}
.u-containar-pc {
  @include mixins.media() {
    max-width: calc(1128px - 16px * 2);
  }
  margin-right: auto;
  margin-left: auto;
}
::v-deep(.localNav_list) {
  display: flex;
}
.pagination {
  width: 100%;
  max-width: 400px;
  margin: 50px auto;
}
</style>
